var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8463 4.03999C10.3063 3.77999 7.99634 4.71999 6.36634 6.34999L5.72634 5.69999C5.09634 5.06999 4.01634 5.51999 4.01634 6.40999V9.99999C4.01634 10.55 4.46634 11 5.01634 11H8.60634C9.49634 11 9.93634 9.91999 9.30634 9.28999L7.79634 7.77999C8.87634 6.68999 10.3563 5.99999 12.0163 5.99999C15.7563 5.99999 18.7063 9.43999 17.8663 13.32C17.3963 15.54 15.6063 17.35 13.3863 17.84C10.4263 18.5 7.71634 16.96 6.58634 14.53C6.42634 14.2 6.07634 14 5.70634 14C4.96634 14 4.48634 14.77 4.80634 15.44C6.08634 18.13 8.82634 20 12.0163 20C16.7463 20 20.4963 15.91 19.9463 11.06C19.5363 7.38999 16.5163 4.40999 12.8463 4.03999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReset);
export default __webpack_public_path__ + "static/media/ico-reset.edd4c3b62722b06e727e207275b3e49e.svg";
export { ForwardRef as ReactComponent };